import React from 'react';

interface BrokerCardOptionProps {
  userName: string;
  includeCard: boolean;
  onToggle: (checked: boolean) => void;
}

export const BrokerCardOption: React.FC<BrokerCardOptionProps> = ({
  userName,
  includeCard,
  onToggle,
}) => {
  return (
    <div className="p-3.5 bg-sky-50 border border-sky-200 rounded-2xl flex items-center justify-between gap-3">
      <div>
        <span className="text-xs font-black text-sky-900 uppercase block">
          Tarjeta de presentación en Links
        </span>
        <span className="text-[11px] text-sky-700 font-medium">
          Adjuntar datos de {userName} en enlaces
        </span>
      </div>
      <input
        type="checkbox"
        checked={includeCard}
        onChange={(e) => onToggle(e.target.checked)}
        className="w-5 h-5 text-sky-600 rounded cursor-pointer"
      />
    </div>
  );
};
